import {Group, SidebarItem, WorkspaceMember} from "../types";
import {ReactNode} from "react";
import {formatName} from "../utils/formatting";
import {useUserContext} from "../../providers/UserContext";

export const useSidebarIcons = (item: SidebarItem | undefined) => {
  const {groups, getMember, user} = useUserContext();
  if (!item) {
    return [[], []];
  }
  const names: (string|ReactNode)[] = [];
  const icons: ReactNode[] = [];
  if (item.meaningfulGroups) {
    item.meaningfulGroups.forEach(groupId => {
      const group = groups.find(group => group.id === groupId) as Group;
      if (group) {
        names.push(group.name);
        icons.push(<div>{group.emoji}</div>);
      }
    })
  }
  if (item.meaningfulUsers) {
    item.meaningfulUsers.forEach(uid => {
      const member = getMember(uid) as WorkspaceMember;
      const onlyMe = member.id === user?.uid && item.meaningfulUsers?.length === 1 && !item.meaningfulGroups?.length;
      if (member && (member.id !== user?.uid || onlyMe)) {
        const name = formatName(member.displayName)
        names.push(name);
        icons.push(<div>{getMember(member.id || "")?.avatar ?
          (<img src={getMember(member.id || "")?.avatar} alt={member?.displayName || ""} className="w-full h-full rounded-md"/>)
          :
          (<span>{member?.displayName?.substring(0,1)}</span>)
        }</div>);
      }
    })
  }
  return [names, icons];
}
